"use client";

import { useEffect } from "react";
import { withUtm } from "@/shared/utils/withUtm";
import { appendCurrentLandingAttributionToHref } from "./landingAnalytics";

export default function UtmAppender() {
  useEffect(function setup() {
    function getContext() {
      const isBlogPost = !!document.querySelector('main[data-page="blog-post"]');
      const isBlog = isBlogPost || location.pathname.startsWith("/blog");
      const medium = isBlogPost ? "post" : isBlog ? "blog" : "";
      let campaign = "";
      if (isBlogPost) {
        const m = location.pathname.match(/\/blog\/(.+)/);
        campaign = m?.[1] ?? "";
      }
      return { isBlog, medium, campaign };
    }

    function onClick(event: MouseEvent) {
      const target = event.target as Element | null;
      if (!target) return;
      const anchor = (target.closest && target.closest("a")) as HTMLAnchorElement | null;
      if (!anchor) return;
      if (!anchor.hasAttribute("data-cta") || anchor.hasAttribute("data-skip-utm")) return;
      const href = anchor.getAttribute("href") || "";
      if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:"))
        return;

      const attributedHref = appendCurrentLandingAttributionToHref(href);
      if (attributedHref !== href) {
        anchor.setAttribute("href", attributedHref);
      }

      const { isBlog, medium, campaign } = getContext();
      if (!isBlog) return;
      try {
        const appended = withUtm(
          anchor.getAttribute("href") || href,
          "blog",
          medium || "site",
          campaign || undefined
        );
        anchor.setAttribute("href", appended);
      } catch {
        // ignore
      }
    }
    document.addEventListener("click", onClick);
    return function cleanup() {
      document.removeEventListener("click", onClick);
    };
  }, []);
  return null;
}
